<template>
    <div class="range-dropdown d-flex align-items-center p-3">
        <custom-select
                v-model="minModel"
                :options="options.min"
                :clearable="false"
                @input="handleInput"
                class="price-input"
        />
        <div class="to">
            to
        </div>
        <custom-select
                v-model="maxModel"
                :options="options.max"
                :clearable="false"
                @input="handleInput"
                class="price-input"
        />
    </div>
</template>
<script>
    import './RangeDropdown.scss';

    export default {
        name: 'RangeDropdown',
        props: {
            value: {
                type: Object,
                required: true,
                validator: (object) => {
                    return object.hasOwnProperty('min') && object.hasOwnProperty('max');
                }
            },
            options: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                minModel: this.value.min,
                maxModel: this.value.max,
            };
        },
        watch: {
            value: {
                deep: true,
                handler(newVal) {
                    this.minModel = newVal.min;
                    this.maxModel = newVal.max;
                }
            }
        },
        methods: {
            handleInput() {
                this.$emit('input', {min: this.minModel, max: this.maxModel});
            }
        },
    };
</script>
